import {GetItemCounts, useInfiniteReferralsSignUps} from "@twigsby/client-data";
import {
    ContentBlock,
    ContentLoader,
    FlexAlign,
    FlexJustify, InfiniteLoadTrigger, ItemRow, ItemRowHeader, RichEmptyState,
    StackHorizontal,
} from "@twigsby/frontend-framework";
import {FormatLocaleDate} from "@twigsby/helpers";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {ClipboardImage} from "../../../Components/Images/ClipboardImage";
import {CommissionImage} from "../../../Components/Images/CommissionImage";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const SignUps = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    const {
        data,
        status,
        error,
        dataUpdatedAt,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage
    } = useInfiniteReferralsSignUps();

    const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const referralsSentRef = useRef<any>();

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [dataUpdatedAt, data]);

    useEffect(() => {
        updatePageMeta({
            title: t(`settings.sections.${"Sign-Ups"}`)
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t(`settings.sections.${"Sign-Ups"}`)}</h2>
            </StackHorizontal>

            <div className={'card commissions-signups-rows'} ref={referralsSentRef}>
                <ItemRowHeader sticky={true}>
                    <div>{t('settings.referralSignUps.headings.signUpDate')}</div>
                    <div>{t('settings.referralSignUps.headings.commissionSplit')}</div>
                    <div>{t('settings.referralSignUps.headings.commissionEarned')}</div>
                    <div>{t('settings.referralSignUps.headings.commissionUnpaid')}</div>
                    <div>{t('settings.referralSignUps.headings.commissionPaid')}</div>
                </ItemRowHeader>

                {status === "loading" ? (
                    <ContentLoader childHeight={'5em'} childCount={10} />
                ) : status === "error" ? (
                    <ContentBlock error={true} stacked={true} title={error?.name} content={error?.message} />
                ) : (
                    <>
                        {data.pages.map((group, groupIndex) => {
                            if(group.totalRecords === 0) {
                                return (
                                    <RichEmptyState
                                        title={t('settings.referralSignUps.noData.title')}
                                        description={t('settings.referralSignUps.noData.description')}
                                        media={<ClipboardImage />}
                                    />
                                )
                            }

                            return (
                                <>
                                    {group.data.map((commissionEntry, index) => {
                                        return (
                                            <ItemRow
                                                key={`commissionEntry${index}`}
                                                static={true}
                                            >
                                                <div>{FormatLocaleDate(commissionEntry.signUpDate, currentLocale)}</div>
                                                <div>{commissionEntry.commissionSplit}</div>
                                                <div>{commissionEntry.commissionEarned}</div>
                                                <div>{commissionEntry.commissionUnpaid}</div>
                                                <div>{commissionEntry.commissionPaid}</div>
                                            </ItemRow>
                                        )
                                    })}
                                </>
                            )
                        })}

                        {
                            itemCounts.total > 0 && (
                                <InfiniteLoadTrigger
                                    loaded={itemCounts.loaded}
                                    totalCount={itemCounts.total}
                                    hasNextPage={hasNextPage}
                                    fetchNextPage={fetchNextPage}
                                isFetchingNextPage={isFetchingNextPage}
                            />
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export { SignUps }
